// @flow

import LoadingElement from './loadingelement';

export default LoadingElement;
